<div class="rs-form-item">
  <select
    id="ac-selectbox1"
    name="ac-selectbox1"
    class="rs-filled"
    (change)="onProductChange($event.target.value)"
  >
    <option *ngFor="let product of products" [value]="product.accessNumber">
      {{ product.accessNumber }} - {{ product.productDescription }}
    </option>
  </select>
  <label class="rs-form-label" for="ac-selectbox1">{{
    'publicWifi.selector.connection' | translate
  }}</label>
</div>
